import { FT } from 'ft'
import { Sprite } from 'pixi.js'

const $smile = 'player-smile'
const $shake = 'player-shake'

FT.rm.addImage($smile)
FT.rm.addImage($shake)

class Player extends Sprite {
  constructor(temp) {
    super()
    this.anchor.set(0.5)
    this.position.set(FT.stage.centerX - 120, FT.stage.centerY - 100)

    this.render(temp)
  }

  render(temp) {
    const textureName = temp >= 21 ? $smile : $shake
    this.texture = FT.rm.texture(textureName)
  }
}

export default Player
